import { useState, useEffect } from "react";
import axios from "../utils/api";
import { isMarketOpen } from "../utils/marketUtils";

export function useMarketStatus() {
  const [marketOpen, setMarketOpen] = useState(isMarketOpen());
  const [marketData, setMarketData] = useState(null);

  const fetchMarket = async () => {
    try {
      const r = await axios.get("/api/market");
      setMarketData(r.data);
    } catch { /* non-critical */ }
  };

  useEffect(() => {
    const t = setInterval(() => setMarketOpen(isMarketOpen()), 60000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => { fetchMarket(); }, []); // eslint-disable-line

  return { marketOpen, marketData, fetchMarket };
}
